import type { ForteXApi, MapRootName, MasterDataModel } from "@fortex/api";

type EntityCollection<T> = { entities: T[]; count: number; totalCount: number };

export function base64Utf8(text: string): string {
  const bytes = new TextEncoder().encode(text);
  let binary = "";

  for (const byte of bytes) binary += String.fromCharCode(byte);

  return btoa(binary);
}

export function rootListPath(root: MapRootName): string {
  const filter = `Type=Equal&FieldName=IdName&Value=${base64Utf8(root)}&IsMultiSet=false`;
  const paging = `Skip=0&Take=1&Filter=${encodeURIComponent(filter)}`;

  return `masterdata/list?paging=${encodeURIComponent(paging)}`;
}

export function rootIdFromRows(root: MapRootName, rows: MasterDataModel[]): number | null {
  const ids = new Set(rows.map(a => a.id));
  const topLevel = rows.find(a => a.parentMasterData_Id !== null && !ids.has(a.parentMasterData_Id) && (a.parentIdName === null || a.parentIdName === root));

  return topLevel?.parentMasterData_Id ?? null;
}

export async function resolveRootId(api: ForteXApi, root: MapRootName, rows: MasterDataModel[], signal?: AbortSignal): Promise<number | null> {
  const fromRows = rootIdFromRows(root, rows);

  if (fromRows !== null) return fromRows;

  const list = await api.request<EntityCollection<MasterDataModel>>(rootListPath(root), { signal });
  const match = (list?.entities ?? []).find(a => a.idName === root);

  return match?.id ?? null;
}
